var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "users" } },
    [
      _c(
        "b-card",
        {
          attrs: {
            "no-body": "",
            "header-tag": "header",
            "footer-tag": "footer"
          }
        },
        [
          _c(
            "template",
            { slot: "header" },
            [
              _c("div", { staticClass: "total-count mr-3" }, [
                _vm._v("\n        " + _vm._s(_vm.totalRows) + "\n        "),
                _c("span", { staticClass: "label" }, [_vm._v("Users found")])
              ]),
              _vm._v(" "),
              _c("font-awesome-icon", {
                staticClass: "icon",
                attrs: { icon: "filter", "fixed-width": "" }
              }),
              _vm._v(" "),
              _c(
                "b-form-group",
                { staticClass: "mb-0" },
                [
                  _c(
                    "b-form-radio-group",
                    {
                      model: {
                        value: _vm.showDeactivated,
                        callback: function($$v) {
                          _vm.showDeactivated = $$v
                        },
                        expression: "showDeactivated"
                      }
                    },
                    [
                      _c(
                        "b-form-radio",
                        {
                          staticClass: "ml-3",
                          attrs: { value: false },
                          on: {
                            change: function($event) {
                              return _vm.toggleStatusFilter()
                            }
                          },
                          model: {
                            value: _vm.showDeactivated,
                            callback: function($$v) {
                              _vm.showDeactivated = $$v
                            },
                            expression: "showDeactivated"
                          }
                        },
                        [_vm._v("Active Users")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-radio",
                        {
                          attrs: { value: true },
                          on: {
                            change: function($event) {
                              return _vm.toggleStatusFilter()
                            }
                          },
                          model: {
                            value: _vm.showDeactivated,
                            callback: function($$v) {
                              _vm.showDeactivated = $$v
                            },
                            expression: "showDeactivated"
                          }
                        },
                        [_vm._v("Deactivated Users")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "search-box", class: { active: _vm.filter } },
                [
                  _c("div", { staticClass: "input-group" }, [
                    _c("div", { staticClass: "input-group-prepend" }, [
                      _c(
                        "div",
                        { staticClass: "input-group-text" },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "icon",
                            attrs: { icon: "search", "fixed-width": "" }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.filter,
                          expression: "filter"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        placeholder: "Find a user by name or email..."
                      },
                      domProps: { value: _vm.filter },
                      on: {
                        keyup: function($event) {
                          return _vm.searchUsers()
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.filter = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "clear-search",
                        on: {
                          click: function($event) {
                            return _vm.clearSearch()
                          }
                        }
                      },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "icon",
                          attrs: { icon: "times-circle", "fixed-width": "" }
                        })
                      ],
                      1
                    )
                  ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("b-card-body", [
            _c(
              "div",
              {
                staticClass: "d-flex align-items-center justify-content-between"
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "form-inline per-page-selection d-flex align-items-center float-left"
                  },
                  [
                    _c("b-form-select", {
                      attrs: { options: _vm.pageOptions },
                      on: {
                        change: function($event) {
                          _vm.currentPage = 1
                        }
                      },
                      model: {
                        value: _vm.perPage,
                        callback: function($$v) {
                          _vm.perPage = $$v
                        },
                        expression: "perPage"
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "ml-2 per-page-label" }, [
                      _vm._v("Users Per Page")
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary float-right",
                    on: {
                      click: function($event) {
                        return _vm.addUser()
                      }
                    }
                  },
                  [
                    _c("font-awesome-icon", {
                      staticClass: "icon",
                      attrs: { icon: "plus" }
                    }),
                    _vm._v("Add User\n        ")
                  ],
                  1
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "b-table",
            {
              ref: "usersTable",
              attrs: {
                "show-empty": "",
                striped: "",
                responsive: "",
                busy: _vm.loading,
                "sort-by": _vm.sortBy,
                "sort-desc": _vm.sortDesc,
                items: _vm.fetchUsers,
                fields: _vm.fields,
                "current-page": _vm.currentPage,
                "per-page": _vm.perPage,
                "empty-text": "There are no users to display"
              },
              on: {
                "update:busy": function($event) {
                  _vm.loading = $event
                },
                "update:sortBy": function($event) {
                  _vm.sortBy = $event
                },
                "update:sort-by": function($event) {
                  _vm.sortBy = $event
                },
                "update:sortDesc": function($event) {
                  _vm.sortDesc = $event
                },
                "update:sort-desc": function($event) {
                  _vm.sortDesc = $event
                },
                filtered: _vm.onFiltered
              },
              scopedSlots: _vm._u([
                {
                  key: "name",
                  fn: function(data) {
                    return [
                      _c("strong", [_vm._v(_vm._s(data.item.name))]),
                      _vm._v(" "),
                      data.item.useApi
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "badge badge-success float-right ml-1"
                            },
                            [_vm._v("API")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      data.item.roleId === 1
                        ? _c(
                            "span",
                            {
                              staticClass: "badge badge-secondary float-right"
                            },
                            [_vm._v("Admin")]
                          )
                        : _vm._e()
                    ]
                  }
                },
                {
                  key: "status",
                  fn: function(data) {
                    return [
                      _c(
                        "span",
                        {
                          staticClass: "badge badge-md",
                          class:
                            "badge-" + _vm.getUserStatus(data.item.isDeleted)
                        },
                        [_vm._v(_vm._s(_vm.getUserStatus(data.item.isDeleted)))]
                      )
                    ]
                  }
                },
                {
                  key: "clients",
                  fn: function(data) {
                    return [
                      data.item.clients.length
                        ? _c(
                            "ul",
                            {
                              staticClass:
                                "user-clients list-unstyled list-inline mb-0"
                            },
                            _vm._l(data.item.clients, function(client) {
                              return _c(
                                "li",
                                {
                                  key: client.id,
                                  staticClass: "list-inline-item mr-1"
                                },
                                [_vm._v(_vm._s(client.name))]
                              )
                            }),
                            0
                          )
                        : _vm._e()
                    ]
                  }
                },
                {
                  key: "actions",
                  fn: function(data) {
                    return [
                      !data.item.isDeleted
                        ? _c(
                            "div",
                            { staticClass: "float-right" },
                            [
                              _c(
                                "b-dropdown",
                                {
                                  attrs: {
                                    right: "",
                                    "no-flip": "",
                                    variant: "link",
                                    "no-caret": ""
                                  }
                                },
                                [
                                  _c(
                                    "template",
                                    { slot: "button-content" },
                                    [
                                      _c("font-awesome-icon", {
                                        attrs: { icon: "ellipsis-h" }
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "sr-only" }, [
                                        _vm._v("Edit User")
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-dropdown-item",
                                    {
                                      attrs: { href: "#" },
                                      on: {
                                        click: function($event) {
                                          return _vm.editUser(data.item)
                                        }
                                      }
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        staticClass: "mr-2",
                                        attrs: {
                                          icon: "pencil-alt",
                                          "fixed-width": ""
                                        }
                                      }),
                                      _vm._v("Edit User\n            ")
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-dropdown-item",
                                    {
                                      attrs: { href: "#" },
                                      on: {
                                        click: function($event) {
                                          return _vm.resendEmail(data.item.id)
                                        }
                                      }
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        staticClass: "mr-2",
                                        attrs: {
                                          icon: "envelope",
                                          "fixed-width": ""
                                        }
                                      }),
                                      _vm._v("Resend Email\n            ")
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-dropdown-item",
                                    {
                                      attrs: { href: "#" },
                                      on: {
                                        click: function($event) {
                                          return _vm.resetPassword(data.item.id)
                                        }
                                      }
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        staticClass: "mr-2",
                                        attrs: {
                                          icon: "user-lock",
                                          "fixed-width": ""
                                        }
                                      }),
                                      _vm._v(
                                        "Log Out and Reset Password\n            "
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.authUser.id != data.item.id
                                    ? _c("b-dropdown-divider")
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.authUser.id != data.item.id
                                    ? _c(
                                        "b-dropdown-item",
                                        {
                                          staticClass: "text-danger",
                                          attrs: { href: "#" },
                                          on: {
                                            click: function($event) {
                                              return _vm.deleteUser(
                                                data.item.id,
                                                data.item.name
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("font-awesome-icon", {
                                            staticClass: "mr-2",
                                            attrs: {
                                              icon: "ban",
                                              "fixed-width": ""
                                            }
                                          }),
                                          _vm._v(
                                            "Deactivate User\n            "
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                2
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  }
                }
              ])
            },
            [
              _c(
                "div",
                {
                  staticClass: "text-center text-danger my-2",
                  attrs: { slot: "table-busy" },
                  slot: "table-busy"
                },
                [
                  _c("b-spinner", {
                    staticClass: "align-middle",
                    attrs: { variant: "primary" }
                  })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c("template", { slot: "footer" }, [
            _c(
              "div",
              {
                staticClass: "d-flex align-items-center justify-content-between"
              },
              [
                _c("span", [
                  _vm._v(
                    "Page " +
                      _vm._s(_vm.currentPage) +
                      " of " +
                      _vm._s(_vm.totalPages)
                  )
                ]),
                _vm._v(" "),
                _c("b-pagination", {
                  attrs: {
                    "total-rows": _vm.totalRows,
                    "per-page": _vm.perPage
                  },
                  model: {
                    value: _vm.currentPage,
                    callback: function($$v) {
                      _vm.currentPage = $$v
                    },
                    expression: "currentPage"
                  }
                })
              ],
              1
            )
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "userModal",
          attrs: {
            size: "lg",
            centered: "",
            "hide-header-close": "",
            title: _vm.isEditing ? "Edit User" : "Add New User"
          }
        },
        [
          _c("form", { attrs: { autocomplete: "off" } }, [
            _c("div", { staticClass: "form-row" }, [
              _c("div", { staticClass: "col" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Name")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "required" }, [_vm._v("*")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.name,
                        expression: "user.name"
                      }
                    ],
                    staticClass: "form-control",
                    class: { "is-invalid": _vm.validationErrors.name },
                    attrs: {
                      type: "text",
                      autocomplete: "off",
                      required: "true"
                    },
                    domProps: { value: _vm.user.name },
                    on: {
                      blur: function($event) {
                        _vm.pristineName = false
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.user, "name", $event.target.value)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.validationErrors.name
                    ? _c("p", { staticClass: "invalid-feedback" }, [
                        _vm._v(_vm._s(_vm.validationErrors.name))
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Email Address")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "required" }, [_vm._v("*")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.email,
                        expression: "user.email"
                      }
                    ],
                    staticClass: "form-control",
                    class: { "is-invalid": _vm.validationErrors.email },
                    attrs: {
                      type: "email",
                      autocomplete: "off",
                      required: "true",
                      disabled: _vm.isEditing
                    },
                    domProps: { value: _vm.user.email },
                    on: {
                      blur: function($event) {
                        _vm.pristineEmail = false
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.user, "email", $event.target.value)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.validationErrors.email
                    ? _c("p", { staticClass: "invalid-feedback" }, [
                        _vm._v(_vm._s(_vm.validationErrors.email))
                      ])
                    : _vm._e()
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-row" }, [
              _c("div", { staticClass: "col" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("User Role")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("b-form-select", {
                        attrs: { options: _vm.roleOptions },
                        model: {
                          value: _vm.user.roleId,
                          callback: function($$v) {
                            _vm.$set(_vm.user, "roleId", $$v)
                          },
                          expression: "user.roleId"
                        }
                      })
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("API Access")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          model: {
                            value: _vm.user.useApi,
                            callback: function($$v) {
                              _vm.$set(_vm.user, "useApi", $$v)
                            },
                            expression: "user.useApi"
                          }
                        },
                        [_vm._v("Allow API access")]
                      )
                    ],
                    1
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("h4", { staticClass: "mb-3" }, [_vm._v("Add clients")]),
            _vm._v(" "),
            _c("div", { staticClass: "client-search" }, [
              _c(
                "div",
                { staticClass: "search-input" },
                [
                  _c("font-awesome-icon", {
                    staticClass: "icon",
                    attrs: { icon: "search" }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.searchClients,
                        expression: "searchClients"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      placeholder: "Find a client by name..."
                    },
                    domProps: { value: _vm.searchClients },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.searchClients = $event.target.value
                        },
                        _vm.onSearch
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _vm.searchClients != ""
                    ? _c("font-awesome-icon", {
                        staticClass: "clear-search",
                        attrs: { icon: "times-circle" },
                        on: {
                          click: function($event) {
                            return _vm.clearClientSearch()
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isOpen,
                      expression: "isOpen"
                    }
                  ],
                  staticClass: "search-results"
                },
                [
                  !_vm.filteredClients.length
                    ? _c("div", [_vm._v("No clients found")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.filteredClients, function(client) {
                    return _c(
                      "div",
                      {
                        key: "a_" + client.id,
                        staticClass: "client-item add-client",
                        class: {
                          selected: _vm.inArray(client, _vm.user.clients)
                        },
                        on: {
                          click: function($event) {
                            return _vm.selectClient(client)
                          }
                        }
                      },
                      [
                        _c("p", [
                          _vm._v(
                            "\n              " +
                              _vm._s(client.name) +
                              "\n              "
                          ),
                          _c(
                            "span",
                            {
                              staticClass:
                                "text-secondary smallclientidtext ml-1"
                            },
                            [_vm._v(_vm._s(client.id))]
                          )
                        ]),
                        _vm._v(" "),
                        _c("font-awesome-icon", {
                          staticClass: "icon",
                          attrs: { icon: "check-circle" }
                        })
                      ],
                      1
                    )
                  })
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "selected-clients" },
              [
                _c("h4", [_vm._v("Selected Clients")]),
                _vm._v(" "),
                !_vm.user.clients.length
                  ? _c("p", { staticClass: "mb-0 empty-state-text" }, [
                      _vm._v("Must select at least one client")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.user.clients, function(client) {
                  return _c(
                    "div",
                    {
                      key: "b_" + client.id,
                      staticClass: "client-item remove-client",
                      on: {
                        click: function($event) {
                          return _vm.removeClient(client)
                        }
                      }
                    },
                    [
                      _c("p", [
                        _vm._v(
                          "\n            " +
                            _vm._s(client.name) +
                            "\n            "
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "text-secondary smallclientidtext ml-1"
                          },
                          [_vm._v(_vm._s(client.id))]
                        )
                      ]),
                      _vm._v(" "),
                      _c("font-awesome-icon", {
                        staticClass: "icon",
                        attrs: { icon: "times" }
                      })
                    ],
                    1
                  )
                })
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c("template", { slot: "modal-footer" }, [
            !_vm.isEditing
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { disabled: _vm.invalidForm || _vm.isSubmitting },
                    on: {
                      click: function($event) {
                        return _vm.saveUser()
                      }
                    }
                  },
                  [
                    !_vm.isSubmitting
                      ? _c("span", [_vm._v("Add User")])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isSubmitting
                      ? _c("font-awesome-icon", {
                          staticClass: "mr-2",
                          attrs: { icon: "spinner", spin: "" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isSubmitting
                      ? _c("span", [_vm._v("Adding User...")])
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isEditing
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { disabled: _vm.invalidForm || _vm.isSubmitting },
                    on: {
                      click: function($event) {
                        return _vm.updateUser()
                      }
                    }
                  },
                  [
                    !_vm.isSubmitting
                      ? _c("span", [_vm._v("Update User")])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isSubmitting
                      ? _c("font-awesome-icon", {
                          staticClass: "mr-2",
                          attrs: { icon: "spinner", spin: "" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isSubmitting
                      ? _c("span", [_vm._v("Updating User...")])
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-outline-secondary",
                on: {
                  click: function($event) {
                    return _vm.hideModal()
                  }
                }
              },
              [_vm._v("Cancel")]
            )
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-040e3608", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-040e3608","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Users.vue
// module id = zMf/
// module chunks = 1